var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3411 5.62305L3.47021 5.74792L3.52776 26.049L36.3987 25.9242L36.3411 5.62305Z",
    fill: "#E66100"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8575 11.941L3.39368 25.9134L36.5341 25.9167L19.8575 11.941Z",
    fill: "#D1D3D4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8799 19.7254L3.47035 5.74504L36.3399 5.61692L19.8799 19.7254Z",
    fill: "#FF9548"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.936c0b3e4b170117015445a3cefea2a2.svg";
export { ForwardRef as ReactComponent };